import * as React from "react";
import * as $ from "jquery";
import * as ReactDOM from "react-dom";
import Modal from "../../avernus/Modal/source/Modal";
import {DragAndDrop, IGalleryItem} from "../../avernus/DragAndDrop/source/DragAndDrop";
import {Uploader} from "../../avernus/uploader/source/Uploader";
import { IGalleryProps, IGalleryState, IRemoveEventResult, IUpdateItemsResult, IUploadImageResult, IGetSourceResult } from "../../../interfaces/models/IGallery";
import RunOnce from "../../avernus/runonce/source/RunOnce";

export class Gallery extends React.Component<IGalleryProps, IGalleryState>{

    constructor(props:IGalleryProps){
		super(props);
		// set initial state
		var exts = [ 'jpg', 'jpeg', 'png' ];
		var size_arr:any = [
			{
				width: 1366,
				height: 768
			},
			{
				width: 960,
				height: 720
			},
			{
				width: 150,
				height: 150,
                modify: 'crop'
			}
		];
		this.state = {
			items : [],
			file: '',
			extensions: exts,
			sizes: size_arr,
			errors : []
        };
    }

    componentDidMount() {
		this.getSource();
    }

	private getSource():void{
		/*showLoader();*/
        var url = '/event/gallery/getGallery';
        var sData:any = {
            small_image: true,
            extensions: this.state.extensions,
            eventId: this.props.eventId
        };
        if ( this.props.userId !== undefined ) {
            url = '/user/gallery/getGallery';
            sData = {
                small_image: true,
                extensions: this.state.extensions,
                userId: this.props.userId
            };
        }
		$.ajax({
			data:           sData,
			type: 			"POST",
			url: 			url,
			contentType:    "application/x-www-form-urlencoded;charset=UTF-8",
			success: (data:IGetSourceResult) => {
				/*hideLoader();*/
				this.setState({
					items : data.items
		        } as IGalleryState, ()=>{
                    if ( data.items.length === 0 && this.props.editMode === false ) {
                        $('#gallery_comp').parent().addClass('hide');
                    }else{
                         $('#gallery_comp').parent().removeClass('hide');
                    }
                });
			}
	    });
	}

	private changedSortableHandler(items): void {
        if ( this.props.editMode === true ) {
		    this.updateItem(this.state.items);
        }
    }


	private titleChangeHandler(item, title:string):void{
        if ( this.props.editMode === true ) {
            var current_items:Array<IGalleryItem> 	= this.state.items;
            var item_index:number 	= current_items.indexOf(item);
            //save title
            if ( item_index > -1 ) {
                current_items[item_index].title = title;
                this.updateItem(current_items);
                this.setState({
                    items: current_items
                } as IGalleryState);
            }
		}
	}

	private updateItem(items:any):void{
		/*showLoader();*/
        RunOnce.run(()=>{
            $.ajax({
                data:{
                    'items'          : items,
                    'eventId'        : this.props.eventId
                },
                type:               "POST",
                url:  				'/event/gallery/updateItems',
                contentType:        "application/x-www-form-urlencoded;charset=UTF-8",
                success: (data:IUpdateItemsResult) => {
                    /*hideLoader();*/
                }
            });
        });
	}

	private removeClickHandler(e, item): void {
		e.preventDefault();
        if ( this.props.editMode === true ) {
            var items_length:number = this.state.items.length;
            var current_items 		= this.state.items;
            var item_index:number 	= current_items.indexOf(item);
            if ( item_index > -1 ) {
                this.removeItem(current_items[item_index].id);
                current_items.splice(item_index,1);
                if ( items_length !== current_items.length ) {
                    this.setState({
                        items: current_items
                    } as IGalleryState);
                }
            }
		}
	}

	private removeItem(id:number):void{
		/*showLoader();*/
		$.ajax({
			data:{
				'id'             : id
			},
			type:               "POST",
			url:  				'/event/gallery/removeImage',
			contentType:        "application/x-www-form-urlencoded;charset=UTF-8",
			success: (data:IRemoveEventResult) => {
				/*hideLoader();*/
			}
	    });
	}

	private beforeDragChangeHandler():void{
        if ( this.props.editMode === true ) {
            var items = this.state.items;
            if ( items !== this.state.items) {
                this.setState({
                    items: items
                } as IGalleryState);
            }
		}
	}

	submitHandler(items):void {
        if ( this.props.editMode === true ) {
            var file:string = null;
            var file_name:string = null;
            var maxFiles:number = items.length;
            if ( maxFiles > 0 ) {
                for (var key in items) {
                    var item = items[key];
                    file = item.file;
                    file_name = item.file_name;
                    this.setState({
                        file: file
                    } as IGalleryState);
                    $.ajax({
                        data:{
                            file: 		file,
                            file_name: 	file_name,
                            eventId: 	this.props.eventId
                        },
                        type:               "POST",
                        url : 				'/event/gallery/uploadImage',
                        contentType:        "application/x-www-form-urlencoded;charset=UTF-8",
                        success: (data:IUploadImageResult) => {
                            if ( data.success !== undefined && data.success === true ) {
                                if ( maxFiles === parseInt(key)+1 ) {
                                    this.getSource();
                                }
                            }else if( data.error !== undefined ){
                                this.setState({
                                    errors : [ data.error ]
                                } as IGalleryState);
                            }
                        }
                    });
                }
            }else{
                this.setState({
                    file: ''
                } as IGalleryState);
                return;
            }
        }
	}

	private uploadTrigger(evt): void {
		evt.preventDefault();
		$(evt.target).parent().parent().parent().parent().find('.file_uploader_btn:first').trigger('click');
	}


    render() {
        var items = this.state.items;
        var default_message:string = '';
        if ( items.length === 0) {
            default_message = '';
        }
        return (
			<div>
                { default_message }
				<ul className="gallery" data-lightbox="gallery" id="lightbox_loader">
					<DragAndDrop key={ "gallery_" + Math.random() } coponent_id="gallery" template="gallery" items={items}
					changed={ items => this.changedSortableHandler(items) }
					titleChangeHandler={ (item, title) => this.titleChangeHandler(item, title) }
					 beforeDragChangeHandler={ () => this.beforeDragChangeHandler() }
					 removeClickHandler={ (e, item) => this.removeClickHandler(e, item) }
                     editMode= { this.props.editMode }
					 />
				</ul>
                <form className="active_box">
    				<div className="box">
                        <div className="col2">
                            <button className="btn btn-primary" onClick={ e => this.uploadTrigger(e) }>Feltöltés</button>
                        </div>
    				</div>
                </form>
				<span style={{display:'none'}}>
					<Uploader extensions={this.state.extensions} sizes={this.state.sizes} max_files={ 50 } resizeCallback={ (items) => this.submitHandler(items) } />
				</span>
			</div>
        );
    }
}
export class InitGallery {
    constructor() {
        var div: HTMLDivElement = document.getElementById('gallery_comp') as HTMLDivElement;
        if (div !== null) {
			var data:any = div.dataset;
            if ( data.user_id !== undefined ) {
                ReactDOM.render(<Gallery eventId={0} userId={ data.user_id } editMode={false} />, div);
            }else{
                ReactDOM.render(<Gallery eventId={ data.id } editMode={false} />, div);
            }
        }
    }
}
export class ReInitGallery {
    constructor(editMode:boolean) {
        var div: HTMLDivElement = document.getElementById('gallery_comp') as HTMLDivElement;
        if (div !== null) {
            ReactDOM.unmountComponentAtNode(div);
            var data:any = div.dataset;
            ReactDOM.render(<Gallery eventId={ data.id } editMode={editMode} />, div);
        }
    }
}



// WEBPACK FOOTER //
// ./components/event/Gallery.tsx